<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">{{pageTitle}} {{object.Name}}</h1>
    </div>
    <div class="ui-g-12 ui-xl-6">
        <div class="card">
            <div *ngIf="this.id !== 'new'" class="ui-g form-group">
                <div id="uploadedPhotoWrapper" class="ui-g-12" style="padding: 0px;">
                    <img id="photoToUpload" src="/assets/layout/images/loader.gif" height="100" width="auto" />
                </div>
                <div class="ui-g-12" style="padding-top: 0px;">
                    <p-fileUpload 
                        id="photo" 
                        name="photo" 
                        [url]="this.urlPicturePost" 
                        (onUpload)="onUpload($event)" 
                        [showUploadButton]="this.id !== 'new' && this.allowUpload === true" 
                        [showCancelButton]="false" 
                        (onSelect)="onPictureSelect($event)"
                        accept=".jpg,.jpeg,.png">
                    </p-fileUpload>
                </div>
            </div>
            <div class="ui-g form-group">
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input pInputText [(ngModel)]="object.Name">
                        <label>Username</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input pInputText [(ngModel)]="object.FirstName">
                        <label>First name</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input pInputText [(ngModel)]="object.LastName">
                        <label>Last name</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input autocomplete="new-password" type="password" [feedback]="false" pPassword [(ngModel)]="object.Password">
                        <label>Password</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <p-autoComplete [(ngModel)]="object.companies" [suggestions]="this.companies"
                            (completeMethod)="search($event)" field="name" [multiple]="true"></p-autoComplete>
                        <label>Companies</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <!--<p-checkbox name="cg" label="Kreiranje" binary="true" [(ngModel)]="object.C"></p-checkbox>
                    <p-checkbox name="cg" label="Ažuriranje" binary="true" [(ngModel)]="object.U"></p-checkbox>
                    <p-checkbox name="cg" label="Brisanje" binary="true" [(ngModel)]="object.D"></p-checkbox>-->
                    <p-checkbox name="cg" label="Administrator" binary="true" [(ngModel)]="object.A"></p-checkbox>
                </div>
                <div class="ui-g-12">
                    <button type="button"  [disabled]="isDisabled" label="Save" pButton icon="ui-icon-save" (click)="save()"></button>
                    <button type="button"  [disabled]="isDisabled" label="Save & Close" pButton icon="ui-icon-save" (click)="saveAndClose()"></button>
                    <button type="button"  [disabled]="isDisabled" label="Cancel" pButton icon="ui-icon-cancel" (click)="cancel()"></button>
                </div>
            </div>
        </div>
    </div>
</div>
